
import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL +  "/api/Account";

export function getPagers(query) {
  return http.post(`${apiEndpoint}/GetPager?${query}`);
}

export function getAccountById(Id) {
  return http.get(`${apiEndpoint}/${Id}`);
}

export function getDeffCurrById(Id) {
  return http.get(`${apiEndpoint}/GetDefCurrId?id=${Id}`);
}



export function editAccount(obj) {
  if (obj.id !== "new" && obj.id !== "add") {
    return http.put(apiEndpoint, obj);
  } else {
    return http.post(apiEndpoint, obj);
  }
}

export function deleteAccount(Id) {
  return http.delete(`${apiEndpoint}/${Id}`);
}


export function getInitiale(Id) {
  return http.post(`${apiEndpoint}/Initiale/?parentId=${Id}`);
}

export function getAccountes() {
  return http.get(`${apiEndpoint}`);
}

export function getAllParents() {
  return http.post(`${apiEndpoint}/GetAllParent`);
}

export function getAllChildren() {
  return http.post(`${apiEndpoint}/GetAllChildren`);
}


export function GetActiveChildren(obj) {
  return http.post(`${apiEndpoint}/GetActiveChildren`,obj);
}

export function getActiveParents(search, addId) {
  return http.post(
    `${apiEndpoint}/GetActiveParent/?search=${search}&addId=${addId}`
  );
}

export function getActiveAccountSearch(search) {
  return http.post(
    `${apiEndpoint}/GetActiveChildrenSearch/?search=${search}`
  );
}

export function getActiveTreeAccount(search, addId) {
  return http.post(
    `${apiEndpoint}/GetActiveTree/?search=${search}&addId=${addId}`
  );
}

export function getActiveTreeRepAccount(obj) {
  return http.post(`${apiEndpoint}/GetActiveTreeRep`,obj);
}



export function getActAccPopupSearch(search,withClient) {
  return http.post(
    `${apiEndpoint}/GetActiveSearchPopup/?search=${search}&withClient=${withClient===undefined?true:withClient}`
  );
}


export function getAccCatTreeSearch(search) {
  return http.post(process.env.REACT_APP_BASE_URL +  `/api/AccCat/GetTreeSearch/?search=${search}`);
}

export function getActiveParentsURL(search, addId) {
   const params = new URLSearchParams()
  search && params.append("search", search);
  //addId && params.append("addId", addId); 
 
  return `${apiEndpoint}/GetActiveChildrenTest/?${params.toString()}`;
}




export function getAllAccount() {
  return http.post(`${apiEndpoint}/GetAll`);
}

export function getNewAccountCode(Id) {
  return http.post(`${apiEndpoint}/GetNew/?parentId=${Id}`);
}

export function getPagerAccount(current, pageSize) {
  return http.post(
    `${apiEndpoint}/GetPager?PageNumber=${current}&PageSize=${pageSize}`
  );
}



export function deleteImage(Id, fileName) {
  
  return http.post(`${apiEndpoint}/DeleteImage?Id=${Id}&fileName=${fileName}`);
}

